import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutEdiCommControlQuickInfo extends Layout {
}
